import React from "react";
import "./index.scss";
import Layout from "../../Components/Layout";
const Dashboard = () => {
  return (
    <>
      <Layout />
    </>
  );
};

export default Dashboard;
